/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkflowMeetingNoteRequest
 */
export interface WorkflowMeetingNoteRequest {
    /**
     * Meeting note full text
     * @type {string}
     * @memberof WorkflowMeetingNoteRequest
     */
    note?: string;
}

/**
 * Check if a given object implements the WorkflowMeetingNoteRequest interface.
 */
export function instanceOfWorkflowMeetingNoteRequest(value: object): boolean {
    return true;
}

export function WorkflowMeetingNoteRequestFromJSON(json: any): WorkflowMeetingNoteRequest {
    return WorkflowMeetingNoteRequestFromJSONTyped(json, false);
}

export function WorkflowMeetingNoteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkflowMeetingNoteRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function WorkflowMeetingNoteRequestToJSON(value?: WorkflowMeetingNoteRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'note': value['note'],
    };
}

